import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClientHeader } from "./ClientShell";
import { capi, useNoindex } from "./clientApi";
import { DocRow } from "./CampaignDashboardView";

export default function ClientDocuments() {
  useNoindex();
  const navigate = useNavigate();
  const [me, setMe] = useState(null);
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      const meRes = await capi("/me").catch(() => null);
      if (!meRes || meRes.status === 401) { navigate("/espace-client/connexion"); return; }
      const meData = await meRes.json();
      const r = await capi("/documents").catch(() => null);
      const d = r && r.ok ? await r.json() : [];
      if (!alive) return;
      setMe(meData); setDocs(d); setLoading(false);
    })();
    return () => { alive = false; };
  }, [navigate]);

  const logout = async () => { await capi("/auth/logout", { method: "POST" }).catch(() => {}); navigate("/espace-client/connexion"); };

  const groups = [];
  const byId = {};
  docs.forEach((doc) => {
    const cid = doc.campaign_id || "_";
    if (!byId[cid]) { byId[cid] = { id: cid, name: doc.campaign_name || "Campagne", items: [] }; groups.push(byId[cid]); }
    byId[cid].items.push(doc);
  });

  return (
    <div className="cp-root" data-testid="cp-documents-page">
      <ClientHeader me={me} onLogout={logout} />
      <div className="cp-page">
        <h1 className="cp-h1" data-testid="cp-docs-h1">Documents</h1>
        <div className="cp-hr" />
        {loading ? (
          <p className="cp-muted" data-testid="cp-docs-loading">Chargement…</p>
        ) : docs.length === 0 ? (
          <div className="cp-panel" data-testid="cp-docs-empty">Aucun document pour le moment.</div>
        ) : (
          groups.map((g) => (
            <div className="cp-panel" key={g.id} data-testid={`cp-docgroup-${g.id}`} style={{ marginBottom: 24 }}>
              <div className="cp-panel-head"><h2 className="cp-panel-title">{g.name}</h2></div>
              <div data-testid="cp-documents-list">
                {g.items.map((doc) => <DocRow doc={doc} key={doc.id} />)}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
